import React from "react";

const Queued = () => {
  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 11.483C4 11.1975 4.23146 10.966 4.51699 10.966H11.7548C12.0403 10.966 12.2718 11.1975 12.2718 11.483C12.2718 11.7685 12.0403 12 11.7548 12H4.51699C4.23146 12 4 11.7685 4 11.483Z"
        fill="#8250DF"
      />
      <path
        d="M4 9.15929C4 8.87377 4.23146 8.6423 4.51698 8.6423H11.7548C12.0403 8.6423 12.2718 8.87377 12.2718 9.15929C12.2718 9.44481 12.0403 9.67627 11.7548 9.67627H4.51699C4.23146 9.67627 4 9.44481 4 9.15929Z"
        fill="#8250DF"
      />
      <path
        d="M4 5C4 4.44772 4.44772 4 5 4H11.2718C11.824 4 12.2718 4.44772 12.2718 5V6.6189C12.2718 7.17118 11.824 7.6189 11.2718 7.6189H5C4.44772 7.6189 4 7.17118 4 6.6189V5Z"
        fill="#8250DF"
      />
    </svg>
  );
};

export default Queued;
